/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  ListLodgingQueryResponse,
  ListLodgingQueryParams,
} from '../types/ListLodging'

function getListLodgingUrl() {
  const res = { method: 'GET', url: `/api/v1/places/lodging/` as const }
  return res
}

/**
 * @summary List lodging chains
 * {@link /api/v1/places/lodging/}
 */
export async function listLodging(
  params?: ListLodgingQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    ListLodgingQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getListLodgingUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
